import { useState } from 'react';
import { getCarReportPDF } from '../services/reportService';

const useGetCarReport = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCarReport = async (vin, paymentDetails) => {
    setLoading(true);
    try {
      const response = await getCarReportPDF(vin, paymentDetails);

      if (response && Array.isArray(response?.data?.data?.data)) {
        const pdfData = new Uint8Array(response.data.data.data);
        const blob = new Blob([pdfData], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        return url; 
      } else {
        setError('Invalid PDF data received');
        return null;
      }
    } catch (err) {
      const msg = err?.response?.data?.message || err.message || 'Unknown error';
      setError(msg);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { fetchCarReport, loading, error };
};

export default useGetCarReport;
